export const backend_domain = "https://supplynest.ribox.me/";
export const api_url = backend_domain + "api/";
export const guest_user = {
  name: "guest",
  api_key: "8c979a0cf56d516",
  api_secret: "f1e23796b0c7ffe",
  email: "",
};
